import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { BASE_URL, UserContext } from '../contexts/UserContext';
import ButtonLoader from '../components/ButtonLoader';
const Dashboard = () => {
  const [posts, setPosts] = useState([]);
  const [deleteLoading, setDeletedLoading] = useState(false);
  const { setError, setMessage} = useContext(UserContext)
  const navigate = useNavigate()

  useEffect(() => {
    const getMyPosts = async () => {
      const { data } = await axios.get(`${BASE_URL}/posts/my-post`,
        {
          headers: { 'Content-Type': 'application/json' },
          withCredentials: true,
        }
      )
      setPosts(data.posts);
    }
    getMyPosts();
  },[]);


  const handleDeletepost = async (postId) => {
    const isTrue = window.confirm("You want to delete this post?");
    if (isTrue) {

      setDeletedLoading(true)
      try {
        const { data } = await axios.delete(`${BASE_URL}/posts/delete/post/${postId}`, {
          withCredentials: true,
        });
        setError(null);
        setMessage(data.message);
      } catch (error) {
        setError(error.response.data.message);
      } finally {
        setDeletedLoading(false);
        navigate('/')
      }
    } else {
      return
    }
  }


  return (
    <section className="dashboard">
      {
        posts.length > 0 ? (
          <div className="container dashboard__container">
            {
              posts.map(post => {
                return (
                  <articla className="dashboard__post">
                    <div className="dashboard__post-info">
                      <div className="dashboard__post-thunbnail">
                        <img src={post.postImg?.secure_url} alt="" />
                      </div>
                      <h5>{post.title.slice(0, 60) + '...'}</h5>
                    </div>
                    <div className="dashboard__post-actions">
                      <Link to={`/posts/${post._id}`} className='btn sm' >View</Link>
                      <Link to={`/post/${post._id}/edit`} className='btn sm primary' >Edit</Link>
                      <Link className='btn sm danger' onClick={() => handleDeletepost(post._id)} >{deleteLoading ? <ButtonLoader/> : 'Delete'}</Link>
                    </div>
                  </articla>
                )
              })
            }
          </div>
        ) : (
          <div className="center">You have no posts yet.</div>
        )
      }
    </section>
  )
}

export default Dashboard